/* -----------------Globals--------------- */
import { useEffect } from "react";

/* -----------------UI--------------- */
import { Dialog } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import { trackCustomEvent } from "analytics";

/* -----------------Child components--------------- */
import FeedbackForm from "../FeedbackForm";

/* -----------------Third party libraries--------------- */
import { DialogWrapper, type IconType } from "@memorang/ui";

import { events } from "@constants/tracking";
import type { FeedbackType } from "@features/feedback/helpers";
import { useTranslation } from "react-i18next";
/* -----------------Constants--------------- */
import { dialogTexts } from "../../constants";

type Props = {
	visible: boolean;
	handleDismiss: () => void;
	view: string;
	feedbackTitle?: string;
	feedbackSubtitle?: string;
	feedbackIcon?: IconType;
	feedbackCta?: string;
	itemId?: string;
	itemFeedbackRating?: "positive" | "negative";
	sessionId?: number;
	threadId?: string;
	runId?: string;
	type?: FeedbackType;
	featureName?: string;
};

export const FeedbackDialog = ({
	visible,
	handleDismiss,
	view,
	feedbackTitle,
	feedbackSubtitle,
	feedbackIcon = "comment-quote-outline",
	feedbackCta,
	itemId,
	itemFeedbackRating,
	sessionId,
	threadId,
	runId,
	type,
	featureName,
}: Props) => {
	const { t } = useTranslation();
	const config = dialogTexts.feedback;

	useEffect(() => {
		if (visible) {
			trackCustomEvent({
				eventName: events.dialogOpened,
				type: "Feedback",
			});
		}
	}, [visible]);

	const handleDismissFeedback = () => {
		handleDismiss();
		trackCustomEvent({
			eventName: events.dialogClosed,
			type: "Feedback",
		});
	};

	return (
		<>
			<DialogWrapper
				visible={visible}
				handleClose={handleDismissFeedback}
				maxWidth="xs"
			>
				<Dialog.Icon icon={feedbackIcon} />
				<Dialog.Title
					style={{
						textAlign: "center",
					}}
				>
					{feedbackTitle || t(config.title)}
				</Dialog.Title>
				<Dialog.Content>
					<FeedbackForm
						view={view || "profile"}
						handleDismiss={handleDismissFeedback}
						feedbackSubtitle={feedbackSubtitle}
						itemId={itemId}
						itemFeedbackRating={itemFeedbackRating}
						sessionId={sessionId}
						threadId={threadId}
						runId={runId}
						type={type}
						featureName={featureName}
						feedbackCta={feedbackCta}
					/>
				</Dialog.Content>
			</DialogWrapper>
		</>
	);
};
